type ScheduleIdleCallbackOptions = {
  /** Max wait before the callback runs even if the browser stays busy. */
  timeout?: number;
};

/**
 * Runs `callback` after the page load event and during an idle period so work
 * does not compete with first paint / hydration.
 */
export const scheduleIdleCallback = (
  callback: () => void,
  { timeout = 2000 }: ScheduleIdleCallbackOptions = {},
) => {
  const run = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout });
    } else {
      setTimeout(callback, timeout);
    }
  };

  if (document.readyState === 'complete') {
    run();
    return;
  }

  window.addEventListener('load', run, { once: true });
};
